import { Box, Button, List, Paper, Stack, Typography } from "@mui/material"
import { IOrderBump } from "../../../../core/types/OrderBump"
import React, { useCallback, useEffect, useState } from "react"
import CheckoutOrderBump8 from "./OrderBump"
import {
  oneMinuteInMilliseconds,
  oneSecondInMilleseconds,
} from "../../../../core/functions/dateTime"
import AddIcon from "@mui/icons-material/Add"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { orange } from "@mui/material/colors"
import Promises from "../../../../core/functions/promises"

interface ICheckoutOrderBumps8 {
  paymentInstallment: number
  paymentMethodType: number
  orderBumps?: IOrderBump[]
  orderBumpChange: (orderBump: IOrderBump) => Promise<void>
}

const CheckoutOrderBumps8 = ({
  paymentInstallment,
  paymentMethodType,
  orderBumps,
  orderBumpChange,
}: ICheckoutOrderBumps8) => {
  const [time, setTime] = useState(oneMinuteInMilliseconds * 10)

  const quantity = orderBumps?.length ?? 0
  //const isOne = quantity <= 1

  const handleChangeOrderbump = useCallback(
    async (orderBump: IOrderBump) => {
      await orderBumpChange(orderBump)
    },
    [orderBumpChange]
  )

  const handleChangeSelectAllOrderbumps = useCallback(async () => {
    const selecteds = orderBumps?.filter((ob) => ob.selected) ?? []
    const isAllSelected = selecteds.length === quantity
    for (const orderBump of orderBumps ?? []) {
      if ((orderBump.selected ?? false) === isAllSelected) {
        orderBump.selected = !isAllSelected
        await handleChangeOrderbump(orderBump)
        await Promises.delay(300)
      }
    }
  }, [orderBumps, handleChangeOrderbump, quantity])

  const getMinutes = () => {
    return ("0" + Math.floor((time / 60000) % 60)).slice(-2)
  }

  const getSeconds = () => {
    return ("0" + Math.floor((time / 1000) % 60)).slice(-2)
  }

  const updateTime = useCallback(() => {
    setTime((t) => t - (t <= 0 ? 0 : oneSecondInMilleseconds))
  }, [setTime])

  useEffect(() => {
    const interval = setInterval(updateTime, oneSecondInMilleseconds)
    return () => clearInterval(interval)
  }, [])

  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #f49332",
        borderRadius: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <Stack direction="column" spacing={2}>
        <Stack
          alignItems="center"
          sx={{
            backgroundColor: "#fef8ef",
            p: 1,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        >
          <Typography
            color="#f49332"
            fontWeight={600}
            fontSize="20px"
            lineHeight="28px"
          >
            ⚡️ OFERTA RELÂMPAGO!
          </Typography>
        </Stack>
        <List sx={{ width: "100%", m: 0, p: 0, margin: 0 }}>
          {orderBumps &&
            orderBumps.map((orderBump) => (
              <CheckoutOrderBump8
                key={`CheckoutOrderBump3${orderBump.id}`}
                paymentInstallment={paymentInstallment}
                paymentMethodType={paymentMethodType}
                orderBump={orderBump}
                onChange={orderBumpChange}
              />
            ))}
        </List>
        {/*<Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={0}
          sx={{ px: 1, pb: 2 }}
        >
          <Typography
            color="#f49332"
            fontWeight={600}
            fontSize={{ xs: "13px", sm: "16px" }}
            lineHeight="20px"
            alignItems="center"
            display="inline-flex"
            sx={{
              fontVariantNumeric: "tabular-nums",
            }}
          >
            Economize 30%
            <AccessTimeIcon sx={{ px: 0.3, color: orange[500] }} />
            {getMinutes()}:{getSeconds()}
          </Typography>
          <Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                color: "#4CBF88",
                borderColor: "#4CBF88",
                backgroundColor: "transparent",
                "&:hover": { borderColor: "#4CBF88" },
                "&:active": { borderColor: "#4CBF88" },
                "&.Mui-focusVisible": { borderColor: "#4CBF88" },
              }}
              onClick={handleChangeSelectAllOrderbumps}
            >
              {(orderBumps?.filter((ob) => ob.selected) ?? []).length ===
              quantity
                ? "Remover Todos"
                : "Adicionar Todos"}
            </Button>
          </Box>
        </Stack>*/}
      </Stack>
    </Paper>
  )
}

export default CheckoutOrderBumps8
